import React from "react";
import { Modal, Button } from "react-bootstrap";

const ResetSuccessModal = ({ show, onHide, onOkClick, message }) => {
    const handleOkClick = () => {
        onOkClick();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
            className="reset-success-modal cstm_padding" 
        >
            {/* <Modal.Header className="border-0 pb-0">
              
            </Modal.Header> */}
            
            <Modal.Body className="text-center py-4">
                <div className="mb-4">
                    <i className="bi bi-shield-check text-success" style={{ fontSize: '75px' }}></i>
                </div>
                <Modal.Title className="text-success mb-3 modal_title" style={{fontSize: '26px'}}>
                    Success
                </Modal.Title>
                <h5 className="mb-3">2FA Reset Successful</h5>
                <p className="text-muted mb-0">
                    {message || "Your 2FA reset link is reset and you can now login normally."}
                </p>
            </Modal.Body>
            
            <Modal.Footer className="border-0 justify-content-center pt-0 pb-0">
                <Button 
                    variant="success" 
                    onClick={handleOkClick}
                    className="px-4 py-2"
                    style={{ minWidth: '100px' }}
                >
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ResetSuccessModal;